<template xmlns:el-table="http://www.w3.org/1999/html">
  <div v-loading="loading" class="CablePrintProperty">
    <el-row style="text-align: left;margin-bottom: 5px">
      <el-button
          type="primary"
          style="margin-top: 5px"
          @click="edit()">
        编辑
      </el-button>
      <el-button
          type="primary"
          :loading="saveLoading"
          :disabled="!editAuth"
          style="margin-top: 5px"
          @click="save()">
        保存
      </el-button>
      <el-button
          type="primary"
          :loading="printLoading"
          :disabled="!printAuth"
          style="margin-top: 5px"
          @click="print()">
        打印
      </el-button>
    </el-row>
    <div style="background: #fff1f0;color: red;border: 1px solid #ff0000;font-size: 15px;font-weight: bold;padding-left: 5px;">订单信息:{{saleOrderNote}}</div>
    <el-table
        :data="details"
        style="width: 100%;overflow-y:scroll"
        border>
      <el-table-column prop="factoryNO" align="center" label="出厂编号" width="150"/>
      <el-table-column
          prop="materialName"
          align="center"
          label="产品名称"
          show-overflow-tooltip
          width="200"/>
      <el-table-column prop="qty" align="center" label="数量" width="50"/>
      <el-table-column prop="length" align="center" label="长度" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.length" :disabled="!editAuth" style="width: 90%"/>
        </template>
      </el-table-column>
      <el-table-column prop="propertyDisplayName" align="center" label="特性名称" width="200"/>
      <el-table-column prop="saleOrderPropertyValue" align="center" label="销售订单特性值" width="350"/>
      <el-table-column prop="propertyDisplayValue" align="center" label="修改后特性值" width="300">
        <template slot-scope="scope">
          <span
              v-show="scope.row.propertyDisplayValue !== scope.row.saleOrderPropertyValue"
              style="color:red;font-size: 30px;max-height: max-content">*</span>
          <el-input v-model="scope.row.propertyDisplayValue" :disabled="!editAuth" style="width: 90%"/>
        </template>
      </el-table-column>
      <el-table-column prop="materialType" align="center" label="线缆类型" width="160">
        <template slot-scope="scope">
          <el-select v-model="scope.row.materialType" :disabled="!editAuth" style="width: 90%">
            <el-option
                v-for="item in constants.materialType1.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @click.native="selectMaterialType(item.value,scope.row)"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="materialNo" align="center" label="物料编号" width="160">
        <template slot-scope="scope">
          <el-input v-model="scope.row.materialNo" :disabled="!editAuth"/>
        </template>
      </el-table-column>
      <el-table-column prop="approveNote" align="center" label="审批意见" width="160"/>
      <el-table-column prop="note" align="center" label="备注" width="160">
        <template slot-scope="scope">
          <el-input v-model="scope.row.note" :disabled="!editAuth"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import constant from "@/util/constant";
  import constants from "@/util/constants";

  export default {
    name: "CablePrintProperty",
    data() {
      return {
        constant,
        constants,
        loading: false,
        dialogVisible: false,
        editAuth: false,
        printAuth: false,
        printLoading: false,
        saveLoading: false,
        details: [],
        purchaseList: [],
        saleOrderNote:"",
      };
    },
    created() {
      console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
      this.purchaseList = this.$route.query.purchaseList;
      this.getData();
      console.log(this.$route.query.purchaseList);
    },
    methods: {
      async getData() {
        this.loading = true;
        this.$http.post("basic", "Cableprintproperties/selectDongliListByOrder", this.purchaseList).then((resp) => {
          console.log(resp);
          this.details = resp;
          this.loading = false;
          this.$nextTick(() => {
            this.initTable();
          });
        });
        this.$http.post("basic", "Cableprintproperties/selectSaleOrderNote", this.purchaseList).then((resp) => {
          console.log(resp);
          this.saleOrderNote = resp;
          this.loading = false;
        });
      },

      edit() {
        this.editAuth = true;
      },
      initTable() {
        //使tableData重新排序
        this.details.forEach((item, index) => {
          item.itemIndex = index;
          item.isChild = false;
        });
      },
      sort() {
        //使tableData重新排序
        this.details.forEach((item, index) => {
          item.itemIndex = index;
        });
      },
      oneDelete(index) {
        this.details.splice(index, 1);
      },
      selectMaterialType(val,row) {
        console.log(row.itemIndex);
        if (val==="动力线") {
          let params = {
            factoryNO:row.factoryNO,
            materialName:row.materialName,
            propertyDisplayName:"线缆规格&功率",
            propertyDisplayValue:"",
            isChild:true,
            qty:row.qty,
            length:row.length,
            materialType:"动力线",
          };
          this.details.splice(row.itemIndex+1,0,params);
          this.sort(this.details);
        }
      },

      save() {
        this.$http.post("basic", "Cableprintproperties/save", this.details).then((resp) => {
          this.$message.success("保存成功");
        }).catch(() => {
          this.$message.error("保存失败");
        });
        this.saveLoading = false;
        this.editAuth = false;
        this.printAuth = true;
      },

      print() {
        this.printLoading = true;
        this.$http
          .postForFile("basic", "Cableprintproperties/printCable", this.details)
          .then((res) => {
            let blob = new Blob([res.data], {type: "application/pdf"});
            let pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl);
            this.printLoading = false;
            this.selection = [];
            this.ids = [];
            this.getList();
          }).catch(() => {
            this.$refs.vmTable.clearSelection();
            this.printLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss">
@media (max-width: 1280px) {
  .salesOrderPreview {
    width: 97%;
    overflow-x: scroll;
  }
}

.salesOrderPreview {
  .el-table th {
    background: #D1E6F5;
    height: 34px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #EBEEF5;
    border-bottom: none;
    border-left: none;
  }

  table.gridtable tr td {
    padding: 8px;
    border-left: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
    border-left: 1px solid #EBEEF5;
  }

  .el-button {
    margin-left: 0 !important;
    margin-right: 5px !important;
  }
}
</style>
